// NAV-010's routes (user-flows §1): AWS accounts (SCR-014), the session list, the session console
// (SCR-015) and change approval (SCR-016). Every route needs `installer:run`; the extra
// `installer:approve` gates on SCR-016 itself (approve/reject controls), not the route.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { AwsAccounts } from "./accounts";
import { ChangeApproval } from "./change-approval";
import { Console } from "./console";
import { INSTALLER_ACCOUNTS_PATH, INSTALLER_CHANGE_PATH, INSTALLER_INDEX_PATH, INSTALLER_SESSION_PATH } from "./model";
import { SessionList } from "./session-list";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-010", path: INSTALLER_INDEX_PATH, title: "Installer", permission: "installer:run", component: SessionList }),
  defineRoute({ nav: "NAV-010", path: INSTALLER_ACCOUNTS_PATH, title: "Linked AWS accounts", permission: "installer:run", component: AwsAccounts }),
  defineRoute({ nav: "NAV-010", path: INSTALLER_SESSION_PATH, title: "Installer session", permission: "installer:run", component: Console }),
  defineRoute({ nav: "NAV-010", path: INSTALLER_CHANGE_PATH, title: "Change approval", permission: "installer:run", component: ChangeApproval }),
];
